import { useAzureAuth } from "@datamole/wds-azure-auth";

import { useAppDispatch } from "@/store";
import { userLoggedOut } from "@/store/slices/auth.slice";

export const useLogout = () => {
    const dispatch = useAppDispatch();
    const { triggerLogout: logoutAzureAd } = useAzureAuth();

    const handleLogout = () => {
        logoutAzureAd();
        dispatch(userLoggedOut());
    };

    return handleLogout;
};
